export const MethodOptions = [{ value: "Bill Payment", label: "Bill Payment (Direct)" },
{ value: "Gift Card", label: "Gift Card" }, { value: "Other", label: "Other (Please Specify)" }]